import { render } from "./App.vue?vue&type=template&id=2c1b5c02"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2c1b5c02&lang=css"

import exportComponent from "E:\\workspace\\symbolEnglish\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__